//import iView from 'iview';
import Vue from 'vue'
import Router from 'vue-router'
import AccessDenied from './views/AccessDenied.vue'
import PageNotFound from './views/PageNotFound.vue'
//import WebcastBase from './views/WebcastBase.vue'
const WebcastBase = resolve => require(['./views/WebcastBase.vue'], resolve);
//import Home from './views/Home.vue'
const Home = resolve => require(['./views/Home.vue'], resolve);
//import Landing from './views/Landing.vue'
const Landing = resolve => require(['./views/Landing.vue'], resolve);
//import Register from './views/Register.vue'
const Register = resolve => require(['./views/Register.vue'], resolve);
//import Live from './views/Live.vue'
const Live = resolve => require(['./views/Live.vue'], resolve);
//import Embed from './views/Embed.vue'
const Embed = resolve => require(['./views/Embed.vue'], resolve);
//import Speaker from './views/Speaker.vue'
const Speaker = resolve => require(['./views/Speaker.vue'], resolve);
//import StreamSelect from './views/StreamSelect.vue'
const StreamSelect = resolve => require(['./views/StreamSelect.vue'], resolve);
import store from './store'

Vue.use(Router)
//Vue.use(iView);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: 'not-found',
      component: PageNotFound,
    },
    {
      path: '/403',
      name: 'access-denied',
      component: AccessDenied,
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: '/gskcns/register'
    },
    {
      path: '/:shortLink',
      name: 'wc',
      component: WebcastBase,
      children: [
        {
          path: 'landing',
          name: 'landing',
          component: Landing,
        },
        {
          path: 'register',
          name: 'register',
          component: Register,
        },
        {
          path: 'stream-select',
          name: 'streamSelect',
          component: StreamSelect
        },
        {
          path: 'live',
          name: 'live',
          component: Live
        },
        {
          path: 'embed',
          name: 'embed',
          component: Embed
        },
        {
          path: 'speaker',
          name: 'speaker',
          component: Speaker
        }
      ]
    }
  ]
});
/*
router.beforeEach((to, from, next) => {
  store.dispatch('devices/initDevice');
  next();
});
*/


export default router
